<div fxLayoutAlign="center center" class="background" fxLayout="column" fxFlexFill>
  <img fxFlex="50" src="assets/403accesoDenegado.png">
  <div fxFlex="8" fxLayoutAlign="center center">
    <button mat-raised-button [routerLink]="''" color="primary" type="button">Regresar al login</button>
  </div>
</div>
